import { render } from "./AlertDelivery.vue?vue&type=template&id=ab197d8e&ts=true"
import script from "./AlertDelivery.vue?vue&type=script&lang=ts"
export * from "./AlertDelivery.vue?vue&type=script&lang=ts"

import "./AlertDelivery.vue?vue&type=style&index=0&id=ab197d8e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__